import './Select.scss'

import React from 'react'

const Select = ({
  register,
  name,
  errorMessage,
  options,
  emptyValue,
  ...rest
}) => {
  return (
    <div className="SelectField">
      <select className="Select" {...register(name)} {...rest}>
        {options ? (
          options?.map(option => (
            <option
              key={option.id}
              value={option.city}
              data-value={option.zip_code}
            >
              {option.city}
            </option>
          ))
        ) : (
          <option value={emptyValue}>{emptyValue}</option>
        )}
      </select>
      <div className="Error-Container">{errorMessage}</div>
    </div>
  )
}

export default Select
